import styled from 'styled-components';

const TabLayoutContainer = styled.div`
  display: grid;
  grid-template-rows: 50px minmax(0, 1fr);
  flex: 1;
  width: 100%;
`;

export default TabLayoutContainer;